import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const LoadingFallback: React.FC = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: (theme) => theme.palette.background.default,
        }}
    >
        <CircularProgress color="primary" size={40} thickness={4} />
    </Box>
);

export default LoadingFallback;
